export default {
    account: {
        singular: 'space',
    },
    divisions: {
        general: 'Polestar',
    },
    civility: {
        singular: 'titre',
    },
    loyalty: {
        singular: 'brand discovery',
    },
    delivery: {
        singular: 'livraison',
        plural: 'livraisons',
    },
    deliverable: {
        singular: 'livrable',
    },
    delivered: {
        infinitive: 'livrer',
        singular: 'livré',
        plural: 'livrés',
        feminineSingular: 'livrée',
        femininePlural: 'livrées',
    },
    deliveryDate: {
        singular: 'à livrer le',
    },
    dashboard_columns: {
        presented: 'visite',
    },
    presented: {
        singular: 'space visite',
    },
    presentedOther: {
        singular: 'autre visite',
    },
    province: {
        CA: 'province / État',
    },
    portfolio: {
        singular: 'rétention',
        plural: 'rétentions',
        prefix: 'la rétention',
        abr: 'réten.',
    },
    renewal: {
        singular: 'renouvellement',
        plural: 'renouvellements',
    },
    renewed: {
        infinitive: 'retenir',
        singular: 'retenu',
        plural: 'retenus',
    },
    result: {
        singular: 'contacté',
    },
    sale: {
        singular: 'commande',
        plural: 'commandes',
        prefix: 'une commande',
    },
    secondaryAdvisor: {
        singular: 'lead concierge',
    },
    sold: {
        singular: 'commandé',
        plural: 'commandés',
    },
    undelivered: {
        singular: 'non livré',
        plural: 'non livrés',
    },
    version: {
        singular: 'variante',
    },
    walkIn: {
        singular: 'space visit',
        plural: 'space visits',
        prefix: 'space visit',
        abr: 'space',
    },
    certified: 'Certifié',
};
